import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'

import { joinOrganization, getOrganization } from './state'

import { LegalText, LookingToJoin, Main } from '../../../components'
import { UserStepInput } from '../../../components/Forms/UserStep'
import { FormattedMessage } from 'react-intl'

type FormData = {
  displayName: string
}

export function UserStep({ superEnabled }: { superEnabled: boolean }) {
  const dispatch = useDispatch()
  const organization = useSelector(getOrganization)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = (data: any) => {
    dispatch(
      joinOrganization(organization.domain, {
        ...data,
        acceptedPrivacyPolicy: true,
      })
    )
  }

  const { control, formState, handleSubmit } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: { displayName: '' },
  })

  return (
    <Main.Container footer={<LookingToJoin superEnabled={superEnabled} />}>
      <Main.Title>
        <FormattedMessage
          id="organization.join.userStep.title"
          defaultMessage="Tell us a bit about yourself"
          values={{}}
        />
      </Main.Title>
      <UserStepInput<FormData>
        onSubmit={handleSubmit(onSubmit)}
        control={control}
        displayName="displayName"
        isValid={formState.isValid}
        email={{ value: 'jean+dev@slite.com', hidden: false }}
      />
      <LegalText />
    </Main.Container>
  )
}
